import { styled } from '@mui/material/styles';

export const Container = styled('div')({
  position: 'relative',
  width: 'fit-content',
});
